import { Component, OnInit } from '@angular/core';
import { ComponentBase } from '../../core/_infrastructure/classes/componentBase';
import { GlobalService } from '../../core/_infrastructure/classes/services/global.service';
import { UntypedFormBuilder } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { EspeciesGruposFormasService } from '../../_mantenimiento/especies/especiesgruposformas/especiesgruposformas.service';
import { NotificationService } from '../../core/_infrastructure/classes/services/notification.service';
import { AuthService } from '../../core/_infrastructure/classes/services/auth.service';
import { ExceptionManager } from '../../core/_infrastructure/classes/handlers/exceptionManager';
import { Tc, WBotanicaExtendedViewModel } from '../../core/_infrastructure/types/common';
import { NombreCientificoService } from '../../_mantenimiento/especies/nombrescientificos/nombrecientifico.service';

@Component({
    selector: 'app-buscadorespecies-detail',
    templateUrl: './buscadorespecies-detail.component.html',
})
export class BuscadorEspeciesDetailComponent extends ComponentBase implements OnInit {
    listGrupo: Tc[];
    listForma: Tc[];
    listSubForma: Tc[];

    public isCollapsedCabeceraEspecieVegetal = false;
    public isCollapsedDatosEspecieVegetal = false;

    especiesGruposFormas: WBotanicaExtendedViewModel;

    constructor(
        private activatedRoute: ActivatedRoute,
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        protected notificationService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private especiesGruposFormasService: EspeciesGruposFormasService,
        private nombreCientificoService: NombreCientificoService,
    ) {
        super(authService, notificationService, exceptionHandler);
        this.especiesGruposFormas = new WBotanicaExtendedViewModel();
    }

    ngOnInit() {
        this.createForm();

        this.globalService.getGrupos().subscribe(res => {
            this.listGrupo = res;
        });

        let id = +this.activatedRoute.snapshot.params['id'];

        this.especiesGruposFormasService.getDatosWBotanicaExtendedById(id).subscribe(result => {
            this.especiesGruposFormas = result;

            this.globalService.getFormasByGrupo(this.especiesGruposFormas.IdGrupo).subscribe(res => {
                this.listForma = res;
            });
            this.globalService.getSubFormasByForma(this.especiesGruposFormas.IdForma).subscribe(res => {
                this.listSubForma = res;
            });

            //añadir a la lista de nombres cientí­ficos el que tiene asignado actualmente
            let currentNombreCientifico = new Tc();
            currentNombreCientifico.Id = this.especiesGruposFormas.IdNombreCientifico;
            currentNombreCientifico.Descripcion = this.especiesGruposFormas.IdNombreCientificoDescripcion;

            let currentNombreCientificoArray = new Array<Tc>();
            currentNombreCientificoArray.push(currentNombreCientifico);

            this.updateForm();
        });

        this.isCollapsedCabeceraEspecieVegetal = false;
        this.isCollapsedDatosEspecieVegetal = false;

        //Deshabilitamos los combos y los toogle buttons
        this.form.controls['IdGrupo'].disable();
        this.form.controls['IdForma'].disable();
        this.form.controls['IdSubForma'].disable();

        this.form.controls['Activa'].disable();
        this.form.controls['HabilitadoImportacion'].disable();
        this.form.controls['HabilitadoExportacion'].disable();
        this.form.controls['HabilitadoChina'].disable();
    }

    createForm() {
        this.form = this.fb.group({
            IdGrupo: null,
            IdForma: null,
            IdSubForma: null,
            CodigoEppo: '',
            IdNombreCientificoDescripcion: '',
            NombreComun: '',
            Activa: null,
            HabilitadoImportacion: null,
            HabilitadoExportacion: null,
            HabilitadoChina: null,
        });
    }

    updateForm() {
        this.form.setValue({
            IdGrupo: this.especiesGruposFormas.IdGrupo,
            IdForma: this.especiesGruposFormas.IdForma,
            IdSubForma: this.especiesGruposFormas.IdSubForma,
            CodigoEppo: this.especiesGruposFormas.CodigoEppo,
            IdNombreCientificoDescripcion: this.especiesGruposFormas.IdNombreCientificoDescripcion,
            NombreComun: this.especiesGruposFormas.NombreComun,
            Activa: this.especiesGruposFormas.Activo,
            HabilitadoImportacion: this.especiesGruposFormas.HabilitadoImportacion,
            HabilitadoExportacion: this.especiesGruposFormas.HabilitadoExportacion,
            HabilitadoChina: this.especiesGruposFormas.HabilitadoChina,
        });
    }

    onBack() {
        this.router.navigate(['/global/buscadorEspecies']);
    }

    onSelectNombre() {
        const idNombreCientifico = this.form.value.IdNombreCientifico;

        //hay que consultar su código Eppo
        this.nombreCientificoService.getDatosNombreCientificoById(idNombreCientifico).subscribe({
            next: result => {
                this.form.patchValue({
                    CodigoEppo: result.CodigoEppo,
                });

                this.isCollapsedDatosEspecieVegetal = false;
            },
            error: error => {
                this.catchServerError(error);
            },
        });
    }

    onSelectGrupo() {
        const idGrupo = this.form.value.IdGrupo;

        this.globalService.getFormasByGrupo(idGrupo).subscribe(res => {
            this.listForma = res;
        });

        this.form.patchValue({
            IdForma: null,
        });
    }

    onSelectForma() {
        const idForma = this.form.value.IdForma;

        this.globalService.getSubFormasByForma(idForma).subscribe(res => {
            this.listSubForma = res;
        });

        this.form.patchValue({
            IdSubForma: null,
        });
    }
}
